module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxNSAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMi45ODQ5IDJMMy4xNTU3NiAxMS40MTY0TDEyLjI5NzIgMjAuMDk1MyIgc3Ryb2tlPSIjNjg2ODY4IiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anniversary/back.svg
// module id = 0BP+
// module chunks = 0